var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"thematic",rawName:"v-thematic"}],class:{
  'feedback-text': true,
  'feedback-text-black': _vm.blackOnly
},on:{"click":_vm.onClick}},[_c('img',{staticClass:"red-rotated",attrs:{"src":require("../assets/hand-red.svg")}}),_c('h4',{directives:[{name:"thematic",rawName:"v-thematic"}]},[_vm._v(_vm._s(_vm.$t('order_buttons.feedback')))]),_c('img',{attrs:{"src":require("../assets/hand-green.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }